<div>
  <div class="row">
    <div class="col-md-12">
      <div style="display: flex">
        <h1 class="aru-title">Settings</h1>

        <a *ngIf="canEdit" routerLink="/setting/form/add" class="btn aru btn-primary">Create new</a>
        <div class="aru-search">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Search"
              [(ngModel)]="searchString"
              (ngModelChange)="loadData()" />
            <div class="input-group-append close" *ngIf="searchString" (click)="searchString = ''; loadData()">
              <span><i class="fa fa-close"></i></span>
            </div>
            <div class="input-group-append search" *ngIf="!searchString">
              <span><i class="fa fa-search"></i></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <br />
  <br />

  <div class="table-wrapper">
    <table class="table aru pointer">
      <thead>
        <tr>
          <th (click)="setOrder('setting.key')">Key <i class="fa" [ngClass]="getOrderIcon('setting.key')"></i></th>
          <th (click)="setOrder('setting.value')">
            Value <i class="fa" [ngClass]="getOrderIcon('setting.value')"></i>
          </th>
          <th (click)="setOrder('setting.description')">
            Description <i class="fa" [ngClass]="getOrderIcon('setting.description')"></i>
          </th>
          <th *ngIf="canEdit">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows" (click)="open($event, row.id)">
          <td>{{ row.key }}</td>
          <td>{{ row.value }}</td>
          <td>{{ row.description || '-' }}</td>
          <td *ngIf="canEdit">
            <div *ngIf="!row.inspectionCount && !row.inspectorCount" class="dropdown" dropdown>
              <button type="button" class="btn" dropdownToggle>
                <i class="fa fa-ellipsis-h"></i>
              </button>
              <div class="dropdown-menu right" *dropdownMenu>
                <a *ngIf="!row.inspectionCount && !row.inspectorCount" class="dropdown-item" (click)="remove(row)"
                  >Delete</a
                >
              </div>
            </div>
          </td>
        </tr>

        <tr>
          <td *ngIf="!rows?.length" colspan="7" style="text-align: center">No records were found.</td>
        </tr>
      </tbody>
    </table>
  </div>
  <pagination
    class="pagination"
    [(ngModel)]="page"
    [totalItems]="count"
    [itemsPerPage]="pageSize"
    [maxSize]="5"
    [boundaryLinks]="true"
    [rotate]="false"
    (pageChanged)="onPageChanged($event.page)">
  </pagination>
</div>
